import React, { useEffect, useState } from "react";
import CampaignService from "../../service/CampaignService";
import { useNavigate } from "react-router-dom";

const CallApplication = ({ kind, customerNo, code, customerInfo }) => {
  const navigate = useNavigate();

  const [selectedTime, setSelectedTime] = useState(null);
  const [memo, setMemo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [times, setTimes] = useState([]);
  const [dates, setDates] = useState([]);

  const handleApply = async () => {
    if (selectedDate === null || selectedDate === "") {
      alert("상담 가능일을 선택해주세요.");
      return;
    }

    if (selectedTime === null || selectedTime === "") {
      alert("상담 가능 시간을 선택해주세요.");
      return;
    }

    try {
      const result = await CampaignService.customerCallRequest(
        kind,
        customerNo,
        code,
        selectedDate,
        selectedTime,
        memo
      );

      if (result) {
        navigate("/callRequestComplete", {
          state: {
            selectedDate: selectedDate,
            selectedTime: selectedTime,
          },
        });
      } else {
        alert("상담신청에 실패하였습니다.");
      }
    } catch (error) {
      // message.error(error?.response?.data?.table1?.[0]?.message || error.message);
      alert("상담신청에 실패하였습니다.");
    } finally {
    }
  };

  useEffect(() => {
    if (customerInfo?.상담시간 === null || customerInfo?.상담시간 === "") {
      setTimes([]);
    } else {
      const _times = customerInfo?.상담시간 || "";
      const timeArray = _times.split(","); // 쉼표로 구분하여 문자열을 배열로 변환

      if (timeArray.length > 0) {
        const formattedTimes = timeArray.map((time) => `${time.trim()}`); // 각 시간 값에 "시" 문자열을 추가
        setTimes(formattedTimes); // 형식이 지정된 시간 배열을 times 상태에 설정
      } else {
        setTimes([]);
      }
    }

    if (customerInfo?.상담일 === null || customerInfo?.상담일 === "") {
      setDates([]);
    } else {
      const _dates = customerInfo?.상담일 || "";
      const dateArray = _dates.split(","); // 쉼표로 구분하여 문자열을 배열로 변환

      if (dateArray.length > 0) {
        const formattedDates = dateArray.map((date) => `${date.trim()}`); // 각 시간 값에 "시" 문자열을 추가
        setDates(formattedDates); // 형식이 지정된 시간 배열을 times 상태에 설정
      } else {
        setDates([]);
      }
    }
  }, [customerInfo]);

  const handleMemoChange = (e) => {
    setMemo(e.target.value);
  };

  return (
    <div className="flex flex-col  min-h-screen md:max-w-[400px] bg-white mx-auto">
      <div className="flex flex-col items-center w-full mb-0   pb-[25px] mt-[100px] gap-3">
        {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover  " /> */}
        <img
          src={customerInfo?.로고경로 || ""}
          className="max-w-[150px]  h-[47px] object-cover mb-2"
        />
        <p className="flex-grow-0 flex-shrink-0 text-lg font-bold text-left text-[#6a6a6a]">
          {customerInfo?.매체 || ""}
        </p>
      </div>

      <div className="flex flex-col w-full px-[22px]">
        <div className="flex flex-col w-full mb-[22px]  ">
          <span className="text-sm font-bold mb-2">상담 가능일</span>
          <input
            type="text"
            value={selectedDate || ""}
            readOnly
            onClick={() => setIsModalOpen(true)}
            className="w-full p-2 border  focus:border-[#3e9ff9] focus:outline-none  border-solid border-gray-300 bg-white "
          />
        </div>

        <div className="flex flex-col w-full mb-[22px] ">
          <span className="text-sm font-bold mb-2">상담 가능 시간</span>
          <div className="flex flex-wrap gap-2">
            {times &&
              times.map((time) => (
                <button
                  key={time}
                  className={`p-2 rounded-1 text-sm font-bold ${
                    selectedTime === time
                      ? "bg-[#3e9ff9] text-white"
                      : "bg-gray-100 text-black"
                  }`}
                  onClick={() => setSelectedTime(time)}
                >
                  {time}
                </button>
              ))}
          </div>
          <span className="text-sm font-semibold mt-4  text-slate-500 ">
            * 가능한 선택하신 시간에 맞춰 연락드리지만, 상담 일정에 따라 변동이
            있을 수 있습니다.
          </span>
        </div>

        <div className="flex flex-col w-full mb-4">
          <span className="text-sm font-bold mb-2">고객 요청사항</span>
          <input
            type="text"
            value={memo || ""}
            onChange={handleMemoChange}
            className="w-full p-2 border  focus:border-[#3e9ff9] focus:outline-none  border-solid border-gray-300 bg-white "
          />
        </div>
      </div>

      {/* <button className="flex justify-center items-center w-full h-12 mt-auto bg-[#3e9ff9] rounded-lg" onClick={handleApply}>
        <span className="text-sm font-bold text-white">상담신청</span>
      </button> */}

      {/* <button className="flex justify-center items-center w-full h-14 mt-auto   bg-[#3e9ff9] rounded-[5px]  " onClick={handleApply}>
        <span className="text-sm font-bold text-white">상담신청</span>
      </button> */}

      <button
        className="flex justify-center items-center w-full h-14 mt-auto   bg-[#3e9ff9]   "
        onClick={handleApply}
      >
        <span className="text-[16px] font-bold text-white">상담신청</span>
      </button>

      {/* <div className="flex flex-col w-full px-[22px] mt-auto">
      <button className="flex justify-center items-center w-full h-12  bg-[#3e9ff9] rounded-[5px]  " onClick={handleApply}>
        <span className="text-sm font-bold text-white">상담신청</span>
      </button>
      </div> */}

      {/* 모달 */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50">
          <div className="fixed inset-x-0 bottom-0 bg-white rounded-t-lg max-h-[80vh]">
            <div className="p-4 border-b">
              <div className="flex justify-between items-center">
                <div className="text-sm font-bold">날짜 선택</div>
                <button
                  className="text-sm font-bold"
                  onClick={() => setIsModalOpen(false)}
                >
                  닫기
                </button>
              </div>
            </div>
            <div className="max-h-[65vh] overflow-y-auto">
              <ul>
                {dates &&
                  dates.map((date) => {
                    const day = new Date(date).toLocaleDateString("ko-KR", {
                      weekday: "long",
                    });
                    return (
                      <li
                        key={date}
                        className="text-sm p-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setSelectedDate(date);
                          setIsModalOpen(false);
                        }}
                      >
                        {`${date} (${day})`}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallApplication;
